import React, {useState, useEffect, FC, useMemo} from 'react';
import * as fonts from '../../../../../util/fonts';
import './styles.scss';
import 'antd/dist/antd.css';
import colors from '../../../../../util/colors';
import * as Yup from 'yup';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../../../util/strings';

import {get, getWithCustomHeaders} from '../../../../../api/api';
import {
  uriGetMedic,
  uriGetMedicCategories,
  uriGetMedicCategoryProcedures,
  uriGetMedicClinics,
  uriGetMedicSpecialities,
  uriGetMedicSpecialityProcedures,
} from '../../../../../api/endpoints';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '../../../../permissions/components/TabPanel';
import AppCarousel from '../../../../../components/app-carousel/AppCarousel';
import {AppCarouselIndicators} from '../../../../../components/app-carousel/AppCarouselIndicators';
import {Typography} from '@mui/material';
import {useMediaQuery} from 'react-responsive';
import TabDetails from './TabDetails';
import ClinicsInfo from './ClinicsInfo';
import ClinicMap from './ClinicMap';
import {filterActiveCategories} from '../../../../../util/utility';

interface Stage2MedicsProps {
  buStyles: any;
  medics: MedicsProps;
  selectedMedic: any;
  labels: typeof strings.pt.rede;
  selectedBu?: any;
  network?: any;
  nextStageClinicsNotGrouped?: any;
  localHistory: any;
  setLocalHistory(value: any): void;
  medicData?: any;
  showPrice: boolean;
  precoEstimadoFuncAtiva: boolean;
  precoEstimadoAtivo: boolean;
  mobileMode: boolean;
  accessToken: any;
}

interface MedicsProps {
  count: number;
  medics: any[];
}

interface LatLngInterface {
  index?: number;
  lat: number;
  lng: number;
}

const Stage2Medics: FC<Stage2MedicsProps> = ({
  medics,
  buStyles,
  labels,
  selectedMedic,
  selectedBu,
  network,
  nextStageClinicsNotGrouped,
  localHistory,
  setLocalHistory,
  medicData,
  precoEstimadoFuncAtiva,
  showPrice,
  mobileMode,
  accessToken,
}) => {
  const medicKey: any = Object.keys(medics.medics).find(
    (el: any) => medics.medics[el].code === selectedMedic
  );
  const medicObject: any = medicData
    ? medicData
    : medicKey
    ? medics.medics[medicKey]
    : {};
  const medicName = medicObject.name;
  const medicGender = medicObject.gender;
  const medicDescription =
    medicObject.speciality && medicObject.speciality.description;
  const email = medicObject.email;
  const phone = medicObject.phone;

  const [tabValue, setTabValue] = useState(0);

  const handleTab = (event: React.ChangeEvent<{}>, value: any) => {
    handleChangeInfoBoxPosition(null);
    setTabValue(value);
    //excluir a tab q nao vem das categories
    if (value < categories.length) {
      const selectedTab = categories[value].description;
      if (selectedTab === 'Exames') {
        getMedicSpecialities();
      } else if (selectedTab === 'Consultas') {
        getConsultas();
      }
    }
  };

  const [clinics, setClinics] = useState<any[]>([]);
  const [examSpecialities, setExamSpecialities] = useState([]);
  const [examList, setExamList] = useState([]);
  const [examListEmpty, setExamListEmpty] = useState(false);
  const [showConsultasError, setShowConsultasError] = useState(false);
  const [showExamsError, setShowExamsError] = useState(false);
  const [showClinics, setShowClinics] = useState(false);
  const [consultas, setConsultas] = useState([]);
  const [showTabs, setShowTabs] = useState(false);
  const [resetScroll, setResetScroll] = useState(true);
  const [expanded, setExpanded] = useState('');
  const [loading, setLoading] = useState(false);

  const [categories, setCategories]: any[] = useState([]);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const [clinicsLoaded, setClinicsLoaded] = useState(false);
  const [infoBoxPosition, setInfoBoxPosition] =
    useState<LatLngInterface | null>(null);
  const [componentIndex, setComponentIndex] = useState(0);

  const handleChangeInfoBoxPosition = (position: any) => {
    setInfoBoxPosition(position);
  };

  const token = accessToken;
  const headers =
    labels?.medicalNetwork_toggleHeaders === 'true'
      ? {
          Unit: selectedBu.buId,
          Family: selectedBu.famId,
          Fiscal: selectedBu.nif,
          Authorization: 'Bearer ' + token,
          Member: selectedBu.memId,
        }
      : {
          Unit: selectedBu.buId,
          Family: selectedBu.famId,
          Fiscal: selectedBu.nif,
          Authorization: 'Bearer ' + token,
        };

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  const scrollToTab = () => {
    setResetScroll(false);
    window.scroll({top: isResponsive ? 700 : 250, behavior: 'smooth'});
  };

  useEffect(() => {
    getCategories();
    getClinics();
    getMedic();
  }, []);

  useEffect(() => {
    if (categoriesLoaded && clinicsLoaded) {
      const selectedTab =
        categories.length > 0 ? categories[tabValue].description : '';

      if (selectedTab === 'Exames') {
        getMedicSpecialities();
      } else if (selectedTab === 'Consultas') {
        getConsultas();
      } else {
        setTabValue(categories.length); // caso as categorias nao tenham nenhuma tab a apresentar, por como tab default a dos hospitais e clinicas
      }

      setShowTabs(categories.length !== 0 || clinics.length !== 0);
    }
  }, [categoriesLoaded, clinicsLoaded]);

  //feito em separado das outras tabs pois esta nao depende de vir ou nao no resultado das categorias
  const getClinics = async () => {
    try {
      await getWithCustomHeaders(
        uriGetMedicClinics(
          selectedMedic ? selectedMedic : medicData.code,
          network
        ),
        headers
      ).then((res: any) => {
        setClinics(res?.data?.clinics);
        if (res?.data?.clinics?.length > 0) {
          setShowClinics(true);
        }
      });
    } catch (e: any) {
      setClinics([]);
    } finally {
      setClinicsLoaded(true);
    }
  };

  const getMedicSpecialities = async () => {
    try {
      await getWithCustomHeaders(
        uriGetMedicSpecialities(
          selectedMedic,
          parseInt(labels.medicalNetwork_exams_code),
          network
        ),
        headers
      ).then((res: any) => {
        if (!res?.data?.specialities || res?.data?.specialities.length === 0) {
          setShowExamsError(true);
        } else {
          setExamSpecialities(res?.data?.specialities);
        }
      });
    } catch {
      setShowExamsError(true);
    }
  };

  const getConsultas = async () => {
    try {
      await getWithCustomHeaders(
        uriGetMedicCategoryProcedures(
          selectedMedic ? selectedMedic : medicData.code,
          network,
          parseInt(labels.medicalNetwork_appointments_code)
        ),
        headers
      ).then((res: any) => {
        if (!res?.data?.procedures || res?.data?.procedures.length === 0) {
          setShowConsultasError(true);
        } else {
          setConsultas(res?.data?.procedures);
        }
      });
    } catch {
      setShowConsultasError(true);
    } finally {
      setShowTabs(true);
    }
  };

  const getCategories = async () => {
    try {
      await getWithCustomHeaders(
        uriGetMedicCategories(
          selectedMedic ? selectedMedic : medicData.code,
          network
        ),
        headers
      ).then((res: any) => {
        const temp = filterActiveCategories(
          labels.medicalNetwork_inactiveCategories,
          res?.data?.categories
        ).sort((a: any, b: any) =>
          a.catCode > b.catCode
            ? parseInt(labels.medicalNetwork_appointments_code)
            : b.catCode > a.catCode
            ? -1
            : 0
        );
        const cat = temp.filter(
          (el: any) =>
            el.description === 'Exames' || el.description === 'Consultas' //por mais a medida que se desbloqueia
        );

        setCategories(cat);
      });
    } catch (e: any) {
    } finally {
      setCategoriesLoaded(true);
    }
  };
  const handleChangeExams =
    (code: any) => async (event: any, isExpanded: any) => {
      setLoading(true);
      setExpanded(isExpanded ? code : false);
      if (isExpanded) {
        try {
          await getWithCustomHeaders(
            uriGetMedicSpecialityProcedures(
              selectedMedic,
              code,
              parseInt(labels.medicalNetwork_exams_code),
              network
            ),
            headers
          ).then((res: any) => {
            setLoading(false);
            setExamList(res?.data?.procedures);
            setExamListEmpty(res?.data?.length === 0);
          });
        } catch {
          setExamListEmpty(true);
          setExamList([]);
          setLoading(false);
        }
      }
    };

  const goToClinicDetail = (clinic: any) => {
    setLocalHistory([...localHistory, 'stage2Clinics']);
    nextStageClinicsNotGrouped(clinic.code, clinics);
  };

  const renderClinicInfo = (clinic: any) => (
    //TODO: refine this
    <ClinicsInfo
      name={clinic.name}
      precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
      phone={clinic.phone}
      email={clinic.email}
      url={clinic.url}
      address={`${clinic.address}, ${clinic.postalCode}, ${clinic.parish} `}
      clinic={clinic}
      goToClinicDetail={goToClinicDetail}
      showPrice={showPrice}
      hideMap
    />
  );

  const renderAppointments = () => {
    return (
      <Typography>
        {!showConsultasError && (
          <div className="consultas-tab-options-container">
            {consultas?.map((consulta: any) => (
              <>
                <div
                  className="option option-container-typo"
                  key={consulta.name}>
                  <div
                    className="tab-option-title"
                    style={{
                      ...fonts.M,
                    }}>
                    {consulta.name}
                  </div>
                </div>
              </>
            ))}
          </div>
        )}
        {showConsultasError && (
          <div className="no-results" style={{...fonts.M}}>
            {labels?.medicalNetwork_clinics_speciality_noInfo}
          </div>
        )}
      </Typography>
    );
  };

  const renderExams = () => {
    return examSpecialities.map((exam: any, index: any) => {
      if (index === examSpecialities.length - 1) {
        resetScroll && scrollToTab();
      }
      return (
        <TabDetails
          procedure={exam}
          dataList={examList}
          expanded={expanded}
          speciality={exam.description}
          handleChange={handleChangeExams}
          listEmpty={examListEmpty}
          loading={loading}
          index={index}
        />
      );
    });
  };

  const renderTabContent = (category: any, index: any) => {
    switch (category.description) {
      case 'Consultas':
        return (
          <TabPanel value={tabValue} index={index}>
            {renderAppointments()}
          </TabPanel>
        );
      case 'Exames':
        return (
          <TabPanel value={tabValue} index={index}>
            {renderExams()}
          </TabPanel>
        );
      // more cases for other tabs in the future
      default:
        return <></>;
    }
  };

  const onSelect = (index: any) => {
    const currentClinic = clinics[index];
    if (currentClinic && currentClinic.latitude && currentClinic.latitude) {
      setInfoBoxPosition({
        index: index,
        lat: currentClinic.latitude,
        lng: currentClinic.longitude,
      });
    }
  };

  useEffect(() => {
    infoBoxPosition?.index && setComponentIndex(infoBoxPosition.index);
  }, [infoBoxPosition]);

  const mapClinics = useMemo(() => {
    return clinics.filter((clinic) => clinic.latitude && clinic.longitude);
  }, [clinics]);

  useEffect(() => {
    if (!clinics || !clinics.length) return;
    handleChangeInfoBoxPosition({
      index: 0,
      lat: clinics[0].latitude,
      lng: clinics[0].longitude,
    });
  }, [tabValue, clinics]);

  const renderTabs = () => {
    return (
      <>
        {showTabs && (
          <div className="tabs tabs-wrapper">
            <Tabs
              className="tab-parent tab-custom"
              value={tabValue}
              orientation="horizontal"
              onChange={handleTab}
              indicatorColor="primary"
              TabIndicatorProps={{style: {backgroundColor: 'transparent'}}}>
              {categories.map((el: any, index: any) => {
                const keyword =
                  el.description === 'Exames' || el.description === 'Consultas';

                return (
                  keyword && (
                    <Tab
                      className="tab tab-header"
                      label={
                        <span
                          style={{
                            ...fonts.M,
                            ...fonts.Bold,
                            color:
                              tabValue === index
                                ? colors.white
                                : buStyles.primaryColor,
                          }}>{`${el.description}`}</span>
                      }
                      wrapped={false}
                    />
                  )
                );
              })}
              {showClinics && (
                <Tab
                  className="tab tab-header hospitais-tab"
                  label={
                    <span
                      style={{
                        ...fonts.M,
                        ...fonts.Bold,
                        color:
                          tabValue === categories.length
                            ? colors.white
                            : buStyles.primaryColor,
                      }}>{`${labels?.medicalNetwork_clinics} (${clinics.length})`}</span>
                  }
                  wrapped={false}
                />
              )}
            </Tabs>
            <div
              className="tab-separator"
              style={{backgroundColor: colors.black}}
            />
            {categories?.map((el: any, index: any) => {
              return renderTabContent(el, index);
            })}
            <TabPanel value={tabValue} index={categories.length}>
              <div className="clinics-tab">
                <div className="app-carousel-wrapper">
                  <AppCarousel
                    componentIndex={componentIndex}
                    setComponentIndex={setComponentIndex}
                    items={clinics ? clinics : []}
                    onSelect={onSelect}
                    renderCarouselItem={(item: any) => renderClinicInfo(item)}
                    className="medic-clinics-carousel"
                    indicatoresClass="medic-clinics clinic-carousel-indicators"
                  />
                  {!mobileMode && (
                    <AppCarouselIndicators
                      componentIndex={componentIndex}
                      setComponentIndex={setComponentIndex}
                      items={clinics ? clinics : []}
                      buStyles={buStyles}
                      onSelect={onSelect}
                      className="medic-clinics clinic-carousel-indicators"
                      currentStyles={buStyles}
                      showNavIcons={true}
                    />
                  )}
                </div>
                <ClinicMap
                  buStyles={buStyles}
                  multipleClinics
                  precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
                  infoBoxPosition={infoBoxPosition}
                  handleChangeInfoBoxPosition={handleChangeInfoBoxPosition}
                  clinics={mapClinics}
                  showPrice={showPrice}
                />
                {mobileMode && (
                  <div className="app-carousel-wrapper">
                    <AppCarouselIndicators
                      componentIndex={componentIndex}
                      setComponentIndex={setComponentIndex}
                      buStyles={buStyles}
                      items={clinics ? clinics : []}
                      onSelect={onSelect}
                      className="medic-clinics carousel-indicators"
                      currentStyles={buStyles}
                      showNavIcons={true}
                    />
                  </div>
                )}
              </div>
            </TabPanel>
          </div>
        )}
        {!showTabs && <></>}
      </>
    );
  };

  const getMedic = async () => {
    try {
      await getWithCustomHeaders(uriGetMedic(selectedMedic), headers);
    } catch {}
  };

  return (
    <div className="medic-name-title-container">
      <span className="medic-title" style={{...fonts.XL, color: colors.black}}>
        {medicGender === 1 ? 'Dr. ' : 'Dra. '} {medicName}
      </span>
      <br />
      {medicDescription && (
        <>
          <span style={{...fonts.ML, color: colors.black}}>
            {medicDescription}
          </span>{' '}
          <br />
        </>
      )}
      {medicObject.email && (
        <span style={{...fonts.SM, color: colors.black}}>
          {labels?.medicalNetwork_clinics_email} {email}
        </span>
      )}
      {renderTabs()}
    </div>
  );
};

const mapStateToProps = ({
  globalStyles,
  strings,
  selectedBu,
  accessToken,
}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.rede,
  selectedBu: selectedBu.value,
  accessToken: accessToken.value,
});

export default compose(connect(mapStateToProps)(Stage2Medics));
